export default {
  webDomain: "http://homecomfortrealty.ca:3011",
};

